<template>
  <section class="product-catalogs">
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="content">
            <h3 class="has-text-info">直接拖曳即可以排序</h3>
          </div>
        </div>
      </div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onAdd">
            <b-icon icon="plus"></b-icon>
            <span>
              {{ $t('attributes.join') + $t('attributes.catalog') }}
            </span>
          </a>
        </p>
      </div>
    </nav>
    <b-table
      :data="regionCatalogs"
      :loading="loading"
      :mobile-cards="false"
      bordered
      draggable
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave"
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        numeric
        centered
        width="80"
        v-slot="props"
      >
        {{ props.row.region_list_catalog_sort }}
      </b-table-column>
      <b-table-column
        field="catalog_code"
        :label="$t('attributes.catalog_code')"
        centered
        width="100"
        v-slot="props"
      >
        {{ props.row.catalog_no }}
      </b-table-column>
      <b-table-column
        field="catalog_name"
        label="類別原名"
        width="250"
        v-slot="props"
      >
        {{ props.row.catalog_name }}
      </b-table-column>
      <b-table-column
        field="name"
        :label="
          $t('attributes.group') +
            $t('attributes.catalog') +
            $t('attributes.name')
        "
        v-slot="props"
      >
        <b-input
          v-model="props.row.region_list_catalog_name"
          name="name"
          :placeholder="
            $t('message.please_input') +
              $t('attributes.group') +
              $t('attributes.name')
          "
          expanded
        >
        </b-input>
      </b-table-column>
      <b-table-column :width="180" label="功能" centered v-slot="props">
        <div class="buttons is-centered">
          <b-button
            type="is-info"
            size="is-small"
            @click.prevent.stop="onSortProduct(props.row)"
          >
            {{ $t('attributes.product') + $t('attributes.sort') }}
          </b-button>
          <b-button
            type="is-danger"
            size="is-small"
            outlined
            @click.prevent.stop="onDelete(props.row)"
          >
            {{ $t('attributes.delete') }}
          </b-button>
        </div>
      </b-table-column>
    </b-table>
    <b-button
      type="is-primary"
      @click="onUpdate"
      style="width: 100%; margin-top: 10px;"
    >
      {{ $t('attributes.update_data') }}
    </b-button>
    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <area-region-catalog-form
        :region-catalog="selectedRegionCatalog"
        @send="onSend"
      />
    </b-modal>

    <b-modal
      :active.sync="isProductListModelActive"
      :can-cancel="false"
      full-screen
      has-modal-card
    >
      <products-from
        :area-code="areaCode"
        :catalog-no="selectedCatalogNumber"
      />
    </b-modal>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import AreaRegionCatalogForm from '@/components/areas/AreaRegionCatalogForm'
import ProductsFrom from '@/components/catalogs/CatalogProductsFrom'

export default {
  name: 'AreaRegionCatalogList',
  components: { AreaRegionCatalogForm, ProductsFrom },
  props: {
    regionNo: {
      required: true,
      type: String
    },
    regionName: {
      required: true,
      type: String
    },
    areaCode: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      sending: false,
      loading: false,
      isFormModalActive: false,

      regionCatalogs: [],
      selectedRegionCatalog: null,
      sortField: 'sort',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',

      draggingRow: null,
      draggingRowIndex: null,

      selectedCatalogNumber: null,
      isProductListModelActive: false
    }
  },
  watch: {
    regionNo(newRegionNo) {
      this.regionNo = newRegionNo
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        if (this.regionNo === null || this.regionNo === '') {
          return
        }
        this.loading = true
        const api = `${AREA_API}/${this.regionNo}/region/catalogs`
        const res = await this.axios.get(api)
        this.regionCatalogs = res.data.data
      } catch (e) {
        this.regionCatalogs = []

        notifyService.fetch_error('region', e)
      } finally {
        this.loading = false
      }
    },
    onAdd() {
      this.selectedRegionCatalog = {
        is_add: true,
        area_code: this.areaCode,
        catalog_no: '',
        region_name: this.regionName,
        region_list_catalog_name: '',
        region_list_catalog_sort: 2,
        region_list_no: this.regionNo
      }
      this.isFormModalActive = true
    },
    async onDelete(item) {
      try {
        const params = {
          catalog_no: item.catalog_no
        }
        const api = `${AREA_API}/region/catalog/delete`

        this.sending = true
        await this.axios.delete(api, { params })

        notifyService.success(this.$t('attributes.delete_succeed'))
        await this.loadData()
        this.$emit('updated', this.regionCatalogs)
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async onSend(item) {
      await this.createItem(item)
    },
    async createItem(item) {
      try {
        const api = `${AREA_API}/region/catalog/create`

        this.sending = true
        const res = await this.axios.post(api, item)
        if (res.data.data !== null) {
          this.$buefy.dialog.alert(res.data)
        }
        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))
        await this.loadData()
        this.$emit('updated', this.regionCatalogs)
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index

      let blocks = [...this.regionCatalogs]

      blocks.splice(this.draggingRowIndex, 1)

      blocks.splice(droppedOnRowIndex, 0, this.draggingRow)

      this.regionCatalogs = blocks.map((b, idx) => {
        return { ...b, region_list_catalog_sort: idx + 1 }
      })
    },
    onSortProduct(catalog) {
      this.selectedCatalogNumber = catalog.catalog_no
      this.isProductListModelActive = true
    },
    async onUpdate() {
      try {
        const api = `${AREA_API}/region/catalog/updateCatalogs`

        this.sending = true
        await this.axios.put(api, this.regionCatalogs)

        await this.loadData()
        this.$emit('updated', this.regionCatalogs)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
